module.exports = __webpack_public_path__ + "static/img/error.57484a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/error.png
// module id = yO/4
// module chunks = 149